export const featuredFlash = {
  id: "flash-featured",
  tag: "本周重点",
  title: "同一事件多版截图集中整理：原始时间戳、转发链路与保存时间已全部标注",
  summary:
    "本周把散落在各处、被反复转发的截图重新归并，逐张标注首次出现时间与保存信息，方便你直接核对细节。",
  image:
    "https://readdy.ai/api/search-image?query=abstract%20evidence%20collection%20concept%20with%20floating%20image%20frames%20and%20timestamp%20labels%2C%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20dark%20textured%20desk%20surface%2C%20cinematic%20editorial%20illustration%2C%20high%20contrast%2C%20no%20text&width=900&height=700&seq=hjhl-flash-featured-01&orientation=landscape",
  updatedAt: "09-10 09:20",
  materials: 46,
};

export const flashNews = [
  { id: "flash-1", tag: "截图", text: "新增 3 组带时间戳的对话截图，已按发生顺序重排", time: "09:20" },
  { id: "flash-2", tag: "录音", text: "2 段录音节选完成文字转写，标注 4 处关键时间点", time: "08:46" },
  { id: "flash-3", tag: "文件", text: "一份 12 页材料扫描件上传，附逐页摘要", time: "08:12" },
  { id: "flash-4", tag: "线索", text: "读者补充两条节点细节，正在交叉核对", time: "07:55" },
  { id: "flash-5", tag: "对比", text: "说法差异对照表更新至第 7 版，新增 2 行", time: "07:30" },
  { id: "flash-6", tag: "投稿", text: "收到 5 条新投稿，已进入人工核验队列", time: "昨天 23:40" },
  { id: "flash-7", tag: "截图", text: "某组截图提供增强版，替换低清版本重新归档", time: "昨天 22:18" },
  { id: "flash-8", tag: "录音", text: "背景音比对结果更新，新增 2 处标注", time: "昨天 21:05" },
  { id: "flash-9", tag: "文件", text: "表格类材料补充字段说明，方便逐项核对", time: "昨天 20:12" },
  { id: "flash-10", tag: "汇总", text: "本周证据索引完成重新排序，按类型分区", time: "昨天 19:30" },
];